export default __webpack_public_path__ + "static/custom-f13742ad079cdb6ce35eff0472f2d335.png";